import {Notifications} from './notifications';

/**
 * Kvitteringer efter en handling (skærm 09). Opdater, Gem, Ryd cache og
 * Opret ordre gav ingen synlig bekræftelse — en kort besked i hjørnet
 * siger hvad der skete uden at afbryde arbejdet.
 *
 * Én delt notyf-instans, så beskeder stables i stedet for at overlappe.
 */

let notifications = null;

function getNotifications() {
    if (!notifications) {
        notifications = new Notifications();
    }

    return notifications;
}

export const receipt = {
    /**
     * Bekræftelse på at handlingen lykkedes.
     *
     * @param {string} message Kort sætning i datid: "Kunden er opdateret".
     * @returns {object} Notyf-beskeden, så den kan fjernes igen.
     */
    success(message) {
        return getNotifications().success(message);
    },

    /**
     * Besked om at handlingen fejlede.
     *
     * @param {string} message Hvad der gik galt.
     * @returns {object} Notyf-beskeden, så den kan fjernes igen.
     */
    error(message) {
        return getNotifications().error(message);
    },

    /**
     * Trækker en besked ud af et svar — men KUN hvis den er skrevet til
     * brugeren.
     *
     * Cloud-koden har 138 engelske fejlstrenge i filer med en HTTP-handler
     * (optalt 13. aug 2026). Langt de fleste er integritetsværn, der kun fyrer
     * på misdannet input: "Lead disappeared while persisting Adversus result",
     * "Unsupported Adversus intent source type". De er skrevet til den, der
     * læser en log — ikke til en dansk supporter midt i en arbejdsdag. Alligevel
     * blev de sendt ordret videre til hendes toast.
     *
     * At oversætte dem alle ville være en stor diff på tekst, ingen bør møde,
     * og det ville gøre logsøgning sværere: fejlen ville hedde én ting i koden
     * og en anden i Sentry. Så i stedet lukkes lækagen her, og cloud kan mærke
     * de FÅ beskeder, der faktisk er skrevet til brugeren, med
     * `user_message: true` — så slipper de igennem.
     *
     * @param {object} payload Svarets data-objekt.
     * @returns {string} Beskeden, eller tom streng hvis den er intern.
     */
    userMessage(payload) {
        if (!payload) {
            return '';
        }

        const erTilBrugeren = payload.user_message === true || payload.user_message === 1;
        return erTilBrugeren ? (payload.message || '') : '';
    },

    /**
     * Vælger kvittering ud fra svaret og trækker beskeden ud af det,
     * så kaldstederne ikke skal grave i wp_send_json-formatet hver gang.
     *
     * @param {object} response wp_send_json-svaret.
     * @param {string} successMessage Tekst når handlingen lykkedes.
     * @param {string} errorMessage Tekst når svaret ikke bærer sin egen.
     * @returns {boolean} Om svaret var en succes.
     */
    fromResponse(response, successMessage, errorMessage) {
        const ok = Boolean(response?.success);
        const serverMessage = this.userMessage(response?.data) || this.userMessage(response);

        if (ok) {
            this.success(serverMessage || successMessage);
            return true;
        }

        this.error(serverMessage || errorMessage);
        return false;
    },

    /**
     * Kvittering for et fejlet kald, hvor beskeden ligger i jqXHR.
     *
     * @param {object} request jqXHR fra jQuery.
     * @param {string} fallback Tekst når svaret ikke bærer sin egen.
     * @returns {object} Notyf-beskeden.
     */
    fromRequestError(request, fallback) {
        const json = request?.responseJSON;
        return this.error(this.userMessage(json?.data) || this.userMessage(json) || fallback);
    },
};

export default receipt;
